import Axios from 'axios';

export default {
  namespaced: true,

  state() {
    return {
      list: [],
      integration_list: [],
      loaded: false
    };
  },

  mutations: {
    set_list(state, v) {
      state.list = v;
    },

    set_integration_list(state, v) {
      state.integration_list = v;
    },

    set_loaded(state, v) {
      state.loaded = v;
    },

    set_is_active(state, data) {
      let item = state.list.filter(i => i.id === data.id)[0];
      item.is_active = data.v;
    }
  },

  actions: {
    load({ commit }, id) {
      commit('set_loaded', false);
      return Axios.get(`/1.0/vacancies/${id}/modules`)
        .then(r => {
          commit('set_list', r.data.data);
          commit('set_loaded', true);
        })
        .catch(e => {
          commit('set_loaded', true);
          return Promise.reject(e);
        });
    },

    loadSilent({ commit }, id) {
      return Axios.get(`/1.0/vacancies/${id}/modules`)
        .then(r => {
          commit('set_list', r.data.data);
        })
        .catch(e => {
          return Promise.reject(e);
        });
    },

    // {vacancy_id, value}
    async save({ commit }, data) {
      commit('set_is_active', { id: data.value.id, v: data.value.is_active });
      return Axios.put(`/1.0/vacancies/${data.vacancy_id}/modules`, { modules: [data.value] });
    }
  },

  getters: {
    list: state => state.list,

    loaded: state => state.loaded,

    allow_tests: state => {
      if (state.loaded) {
        let test = state.list.filter(i => i.id === 'test')[0];
        return test.is_enabled && test.is_active;
      }

      return false;
    },

    allow_integration: state => {
      if (state.loaded) {
        let integration = state.list.filter(i => i.id === 'integration')[0];
        return integration.is_enabled && integration.is_active;
      }

      return false;
    },

    allow_video: state => {
      if (state.loaded) {
        let video = state.list.filter(i => i.id === 'videointerview')[0];
        return video.is_enabled && video.is_active;
      }

      return false;
    },

    allow_application: state => {
      if (state.loaded) {
        let application = state.list.find(i => i.id === 'survey');
        return application ? application.is_enabled && application.is_active : false;
      }

      return false;
    },

    allow_talentq: state => {
      if (state.loaded) {
        let application = state.list.find(i => i.id === 'talentq');
        return application ? application.is_enabled && application.is_active : false;
      }

      return false;
    },

    allow_vi_question_random: state => {
      if (state.loaded) {
        let vi_question_random = state.list.find(i => i.id === 'vi_question_random');
        return vi_question_random ? vi_question_random.is_enabled && vi_question_random.is_active : false;
      }

      return false;
    },

    hasAnticheating: state => {
      const anticheatModule = state.list.find(x => x.id === 'anticheating');

      if (anticheatModule !== -1) {
        return anticheatModule.is_active;
      }

      return false;
    },

    isModuleEnabled: state => moduleName => {
      const module = state.list.find(x => x.id === moduleName);

      if (module !== undefined) {
        return module.is_enabled;
      }

      return false;
    }
  }
};
